import { useQuery } from '@tanstack/react-query'
import { apiRequest } from '@/lib/supabase'

interface Tag {
  id: string
  name: string
  color: string
}

export function useTagsQuery() {
  return useQuery<Tag[]>({
    queryKey: ['tags'],
    queryFn: () => apiRequest<Tag[]>('/api/tags'),
  })
}

export function useUrlTags(urlId: string) {
  return useQuery<Tag[]>({
    queryKey: ['url-tags', urlId],
    queryFn: () => apiRequest<Tag[]>(`/api/urls/${urlId}/tags`),
  })
}
